<template>
  <div>
    <v-row dense v-if="hasNotaVinculada" class="align-center">
      <v-col cols="12" sm="3">
        <px-nota-fiscal-chave-acesso :nota-fiscal="notaFiscalLink.notaFiscal"/>
      </v-col>
      <v-col cols="12" sm="3">
        {{ notaFiscalLink.notaFiscal.dataEmissao | date }}
      </v-col>
      <v-col cols="12" sm="4">
        {{ notaFiscalLink.notaFiscal.totalNotaFiscal | currency }}
      </v-col>
      <v-col cols="12" sm="2" class="text-right">
        <px-nota-fiscal-detalhe-dialog :nota-fiscal="notaFiscalLink.notaFiscal"/>
        <px-update-observacao-nota-fiscal-vinculo-dialog
          class="ml-2"
          :nota-fiscal-vinculo="notaFiscalLink"
          :compra="notaFiscalLink.compra"
          @change="emitChange"
        />
        <v-btn icon :loading="loading" @click="onClickRemove">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-row dense v-else>
      <v-col cols="12" sm="3">
        <px-nota-fiscal-chave-acesso :nota-fiscal="notaFiscalLink"/>
      </v-col>
      <v-col cols="12" sm="6">
        <span v-if="notaFiscalLink.notaFiscalFile">
          <px-anexo-chip :files="notaFiscalFiles"
                         download-base-path="files/download-comprador"/>
        </span>
      </v-col>
      <v-col cols="12" sm="3" class="text-right">
        <px-update-observacao-nota-fiscal-vinculo-dialog
          class="ml-2"
          :nota-fiscal-vinculo="notaFiscalLink"
          :compra="notaFiscalLink.compra"
          @change="emitChange"
        />
        <v-btn icon :loading="loading" @click="onClickRemove">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-row dense v-if="notaFiscalLink.observacaoInterna" class="ml-1">
      <px-show-large-text :large-text="notaFiscalLink.observacaoInterna"/>
    </v-row>
    <px-confirm-dialog ref="confirm"/>
  </div>
</template>

<script>
import NotaFiscalDetalheDialog from '@/modules/notas-fiscais/detalhes/NotaFiscalDetalheDialog.vue';
import NotaFiscalChaveAcesso from '@/modules/notas-fiscais/NotaFiscalChaveAcesso.vue';
import NotasFiscaisCompraLinkService
  from '@/modules/notas-fiscais/notas-fiscais-compra-link-service';
import UpdateObservacaoNotaFiscalVinculoDialog
  from '@/modules/notas-fiscais/vinculo/UpdateObservacaoNotaFiscalVinculoDialog.vue';

const FILE_MAX_LENGTH = 40;

export default {
  props: {
    notaFiscalLink: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    hasNotaVinculada() {
      return !!this.notaFiscalLink.notaFiscal;
    },
    notaFiscalFiles() {
      const file = this.notaFiscalLink.notaFiscalFile;
      if (!file) {
        return [];
      }
      return [{
        ...file,
        // Exibe os últimos caracteres do nome do arquivo se for maior que 30
        // Isso permite manter o tamanho do componente legível
        name: file.name.length > FILE_MAX_LENGTH ? `...${file.name.slice(-FILE_MAX_LENGTH)}` : file.name,
      }];
    },
  },
  methods: {
    emitChange(data) {
      this.$emit('change', data);
    },
    removerLink() {
      this.loading = true;
      NotasFiscaisCompraLinkService.removeLink(
        this.notaFiscalLink.compra.id,
        this.notaFiscalLink.id,
      )
        .then(({ data }) => {
          this.emitChange(data);
          this.$toast.success('Nota fiscal removida da compra');
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onClickRemove() {
      this.$refs.confirm.open('Você deseja remover essa nota da compra?',
        'Esta operação não pode ser desfeita',
        { width: 400 })
        .then((confirm) => {
          if (!confirm) {
            return;
          }
          this.removerLink();
        });
    },
  },
  components: {
    pxNotaFiscalDetalheDialog: NotaFiscalDetalheDialog,
    pxNotaFiscalChaveAcesso: NotaFiscalChaveAcesso,
    pxUpdateObservacaoNotaFiscalVinculoDialog: UpdateObservacaoNotaFiscalVinculoDialog,
  },
};
</script>
